(function ($, $window, $document, $body, Site, Modernizr, _) {

	$.extend(Site, {
		// DOM ready code
		init: function () {
			$(document).foundation();

			var scroll = $(window).scrollTop();
			if (scroll <= 100) {
				$("header.header").removeClass('smaller');
			} else {
				$("header.header").addClass("smaller");
			}

			// --- Toggle for Searchbox --- //
			$('.header-extras .search-button').on('click', function(e){
				e.preventDefault();
				var $form = $('.header-search-form');
				if ($form.hasClass('enabled')) {
					$form.removeClass('enabled').find('input.search-field').blur();
				} else {
					$form.addClass('enabled').find('input.search-field').focus();
				}
			});

			$(window).scroll(function() {
				var scroll = $(window).scrollTop();
				if (scroll <= 100) {
					$("header.header").removeClass('smaller');
				} else {
					$("header.header").addClass("smaller");
				}
			});
			function tranformToX(event) {
				event.preventDefault();
				openOverlay();
				$('.lines-button.arrow.arrow-left').addClass('close');
				$('.lines-button.arrow.arrow-left').addClass('x');
				$('.lines-button.arrow.arrow-left').unbind('click',tranformToX);
				$('.lines-button.arrow.arrow-left').bind('click', tranformToBurger);
				return false;
			}

			function tranformToBurger(event) {
				event.preventDefault();
				closeOverlay();
				$('.lines-button.arrow.arrow-left').removeClass('close');
				$('.lines-button.arrow.arrow-left').removeClass('x');
				$('.lines-button.arrow.arrow-left').unbind('click',tranformToBurger);
				$('.lines-button.arrow.arrow-left').bind('click',tranformToX);
				return false;
			}

			function openOverlay() {
				$('header.header').removeClass('menu-closed').addClass('menu-open');
				$('#overlay').css({'visibility': 'visible'});
			}

			function closeOverlay() {
				$('#overlay').css({'visibility': 'hidden'});
				$('header.header').removeClass('menu-open').addClass('menu-closed');
			}

			$('.lines-button.arrow.arrow-left').on('click', tranformToX);

			function clearActives(parent) {
				if(parent) {
					$('.primary-nav nav > ul > li').not(parent).addClass('not-active');
					parent.addClass('active');
				} else {
					$('.overlay-content').find('.active').removeClass('active');
					$('.overlay-content').find('.not-active').removeClass('not-active');
					$('.overlay-content').find('.copied-link').remove();
				}	
			}

			$('.overlay-content .Nav-menu--depth0 > .Nav-menuItem--hasSubMenu > a').click(function(e){
				e.preventDefault();
				var parent = $(this).parent();
				var cloned = $(this).clone();
				var parent_next = parent.find('.sub-menu').eq(0);
				if(parent.hasClass('active')) {
					parent.removeClass('active');
					parent.find('.active').removeClass('active');
					parent.addClass('not-active');
					parent.find('.not-active').removeClass('not-active');
					parent.find('.copied-link').remove();
					$('.overlay-content .Nav-menu--depth0').find('.active').removeClass('active');
					$('.overlay-content .Nav-menu--depth0').find('.not-active').removeClass('not-active');
					$('.overlay-content .expanded-menu-widget-area').show();
				} else {
					$('.overlay-content .Nav-menu--depth0').find('.active').removeClass('active');
					$('.overlay-content .Nav-menu--depth0').find('.not-active').removeClass('not-active');
					$('.overlay-content .expanded-menu-widget-area').hide();
					parent.find('.copied-link').remove();
					parent.addClass('active');
					parent.removeClass('not-active');
					cloned.prependTo(parent_next).wrap('<li class="copied-link"></li>').append(' Overview');
					parent.siblings('li').addClass('not-active').removeClass('active');
				}
			});

			$('.overlay-content .Nav-menuItem--hasSubMenu .Nav-menuItem--hasSubMenu > a').click(function(e){
				e.preventDefault();
				var parent = $(this).parent();
				var cloned = $(this).clone();
				var parent_next = parent.find('.sub-menu').eq(0);
				
				if(parent.hasClass('active')) {
					parent.removeClass('active');
					$('.overlay-content .Nav-menuItem--hasSubMenu .sub-menu').find('.not-active').removeClass('not-active');
					parent.find('.copied-link').remove();
				} else {
					parent.find('.copied-link').remove();
					parent.addClass('active');
					parent.removeClass('not-active');
					cloned.prependTo(parent_next).wrap('<li class="copied-link"></li>').append(' Overview');
					parent.siblings('li').addClass('not-active').removeClass('active');
				}
			});


			// hide the event calendar list view until a date is clicked
			const upcomingEvents = $('#upcoming-events');
			if ( upcomingEvents.length ) {
				const showUpcomingEvents = function() {
					upcomingEvents.addClass('upcoming-events--active');
					upcomingEvents.off('click', '.tribe-mini-calendar-day-link', showUpcomingEvents);
				}

				upcomingEvents.on('click', '.tribe-mini-calendar-day-link', showUpcomingEvents);
			}

			$('.nice-select').niceSelect().next().find('.option:not(.disabled)').on('click', function() {
				if ( $(this).data('value') ) {
					window.location.href = $(this).data('value');
				}
			});
		},

		// window on load code
		load: function () {
			function equalizeHeights(selector) {
				var heights = new Array();

				// Loop to get all element heights
				$(selector).each(function() {

					// Need to let sizes be whatever they want so no overflow on resize
					$(this).css('min-height', '0');
					$(this).css('max-height', 'none');
					$(this).css('height', 'auto');

					// Then add size (no units) to array
			 		heights.push($(this).outerHeight());
				});

				// Find max height of all elements
				var max = Math.max.apply( Math, heights );

				// Set all heights to max height
				$(selector).each(function() {
					$(this).css('height', max + 'px');
				});	
			}

			// Fix heights on page load
			equalizeHeights('#hp-hero-slider .hero-slider-container .slide');
			equalizeHeights('#featured-events .featured-events-slide');

			// Fix heights on window resize
			var iv = null;
			$(window).resize(function() {

				if(iv !== null) {
					window.clearTimeout(iv);
				}

				// Needs to be a timeout function so it doesn't fire every ms of resize
				iv = setTimeout(function() {
						equalizeHeights('#hp-hero-slider .hero-slider-container .slide');
						equalizeHeights('#featured-events .featured-events-slide');
				}, 120);
			});
		}
	});

	// Make our namespace globally accessible
	window.Site = Site;

	// Run initialization script on DOM ready
	$document.on('ready', Site.init);

	// Defer scripts to window on load event
	$window.on('load', Site.load);

})(window.jQuery, window.jQuery(window), window.jQuery(document), window.jQuery(document.body), window.Site || {}, window.Modernizr, window._);
//# sourceMappingURL=site.js.map
